export const RESET_LAYOUT = 'RESET_LAYOUT'
export const SET_LAYOUT_MODAL_INFO = 'SET_LAYOUT_MODAL_INFO'
export const SET_LAYOUT_VEHICLE_PREVIEW = 'SET_LAYOUT_VEHICLE_PREVIEW'
export const SET_LAYOUT_TRADEIN_PREVIEW = 'SET_LAYOUT_TRADEIN_PREVIEW'

export const resetLayout = () => ({
  type: RESET_LAYOUT
})
export const setLayoutModalInfo = modalInfos => ({
  type: SET_LAYOUT_MODAL_INFO,
  modalInfos
})

export const setLayoutVehiclePreview = vehicle => ({
  type: SET_LAYOUT_VEHICLE_PREVIEW,
  vehicle
})
export const setLayoutTradeInPreview = tradeIn => ({
  type: SET_LAYOUT_TRADEIN_PREVIEW,
  tradeIn
})
